import { MainWrapper } from "@/components/ui/box/MainWrapper";
import { BreadcrumbsBlock } from "@/components/ui/BreadcrumbsBlock";
import { RoslindaleText } from "@/components/ui/text/RoslindaleText";

export const FundsHeader = () => {
  return (
    <MainWrapper
      customStyleOuter={{
        px: { base: "20px", md: "40px" },
        mt: { base: "20px", md: "32px", lg: "28px" },
      }}
    >
      <BreadcrumbsBlock
        {...{
          arrayPath: ["Home", "Research", "Investors"],
        }}
      />
      <RoslindaleText
        customStyle={{
          fontSize: { base: "42px", lg: "54px" },
          mb: { base: "60px", lg: "10px" },
          mt: { base: "40px", lg: "27px" },
        }}
        headingType={"h1"}
      >
        Investors
      </RoslindaleText>
    </MainWrapper>
  );
};
